class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
let timeOut;
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onPointerMove = this.onPointerMove.bind(this);
    this.closeMenu = this.closeMenu.bind(this);

    this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
    this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
  onHoverEnter() {
    timeOut = setTimeout(() => {
      this.querySelector('details').setAttribute('open', '');
    }, 400);

    this.header.setAttribute('megamenuopen', '');
    this.querySelector('summary').setAttribute('aria-expanded', 'true');
    // `pointerover` covers the case where the pointer goes from an overlay
    // straight into an iframe (e.g. a chat widget): the document gets no
    // `pointermove` while over the iframe, but does get `pointerover` on it.
    document.addEventListener('pointermove', this.onPointerMove);
    document.addEventListener('pointerover', this.onPointerMove);
    // Pointer left the browser window entirely.
    document.documentElement.addEventListener('pointerleave', this.closeMenu);
  }
  onHoverLeave(event) {
    // `mouseleave` also fires when the pointer moves onto an element that is
    // layered on top of the menu but not part of it (e.g. a browser
    // extension's floating widget, chat launcher). In that case the pointer is
    // still visually inside the menu, so keep it open; onPointerMove will close
    // it once the pointer actually leaves the menu area.
    if (event && this.isPointerInside(event.clientX, event.clientY)) return;
    this.closeMenu();
  }
  onPointerMove(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!this.isPointerInside(event.clientX, event.clientY)) this.closeMenu();
  }
  isPointerInside(x, y) {
    if (typeof x !== 'number' || typeof y !== 'number') return false;
    return [this, this.content].some((element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.width > 0 &&
        rect.height > 0 &&
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      );
    });
  }
  closeMenu() {
    clearTimeout(timeOut);
    document.removeEventListener('pointermove', this.onPointerMove);
    document.removeEventListener('pointerover', this.onPointerMove);
    document.documentElement.removeEventListener('pointerleave', this.closeMenu);
    this.querySelector('details').removeAttribute('open');
    this.header.removeAttribute('megamenuopen');
    this.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('header-menu', HeaderMenu);
